import React, { useRef } from "react";

import { mdiMenu, mdiTrashCanOutline } from "@mdi/js";
import Icon from "@mdi/react";
import classNames from "classnames";

import useMediaColorByFormat from "@/src/hooks/useMediaColorByFormat";

import prettyDurations, { DURATION_UNITS } from "../../../utils/durations";
import MediaIcon from "../mediaLibrary/MediaIcon";

import type { JSX } from "react";

import type { PlaylistDropzoneMedia } from "../../../types/fast";
import type { DropzoneRenderItemProps } from "../../dropzoneList/DropzoneListContainer";

type DropzoneMediaItemProps = DropzoneRenderItemProps<PlaylistDropzoneMedia>;

export default function DropzoneMediaItem({
  item,
  isDragging,
  isDragDisabled,
  onDeleteClick,
  dragRef: dragConnector,
}: DropzoneMediaItemProps): JSX.Element {
  const dragRef = useRef<HTMLDivElement>(null);

  dragConnector(dragRef);

  const getMediaColor = useMediaColorByFormat();
  const mediaColor = getMediaColor(item?.formatKey);

  const countColumnClassNames = classNames(
    "flex items-center justify-center border-r border-border text-center font-semibold",
    isDragDisabled ? "w-35" : "w-15",
  );

  const prettyMediaDuration = prettyDurations(item.duration, {
    valueUnit: DURATION_UNITS.MILLISECONDS,
  });

  return (
    <React.Fragment>
      <div
        className="h-full w-[0.78125rem]"
        style={{ backgroundColor: mediaColor }}
      />
      {!isDragDisabled && (
        <div
          ref={dragRef}
          className="flex w-20 items-center justify-center"
          style={{
            cursor: isDragging ? "grabbing" : "grab",
          }}
        >
          <Icon color="#98A2B3" path={mdiMenu} size={1.25} />
        </div>
      )}
      <div className={countColumnClassNames}>
        {!isDragDisabled && `#${item.rank + 1}`}
      </div>
      <div className="flex w-20 items-center justify-center" title={item.label}>
        <MediaIcon mediaType={item.type} />
      </div>
      <div
        className="border-border flex w-10 flex-1 shrink items-center border-r pr-[0.78125rem]"
        title={item.label}
      >
        <div className="truncate">{item.label}</div>
      </div>
      <div className="border-border flex w-27.5 items-center justify-center border-r">
        {prettyMediaDuration.humanised}
      </div>
      <div className="flex w-20 items-center justify-center">
        <div
          className="cursor-pointer"
          onClick={(): void => onDeleteClick(item.uuid)}
        >
          <Icon color="#D92D20" path={mdiTrashCanOutline} size={1} />
        </div>
      </div>
    </React.Fragment>
  );
}
